var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEndCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    xmlSpace: "preserve",
    fill: "#fb503b",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.82,71.36l-6.62-7.89c-0.96-1.14-2.3-1.84-3.78-1.97c-1.48-0.13-2.93,0.33-4.07,1.28c-6.1,5.12-15.15,4.6-20.61-1.19  c-1.77-1.88-3.66-3.98-5.64-6.27L76.5,14.77c0.48-0.68,0.31-1.61-0.37-2.09c-0.68-0.48-1.61-0.31-2.09,0.37L46.09,52.96  c-0.1-0.12-0.2-0.23-0.3-0.35c-2.81-3.35-5.32-6.51-7.46-9.38c-4.75-6.38-3.69-15.39,2.41-20.51c2.35-1.97,2.66-5.49,0.69-7.85  l-6.62-7.89c-1.25-1.49-3.15-2.21-5.07-1.93l-15.09,2.2c-2.73,0.4-4.78,2.75-4.77,5.48c0.06,16.6,7.95,35.49,21.64,51.82  c1.18,1.4,2.39,2.75,3.61,4.07L23.5,85.23c-0.48,0.68-0.31,1.61,0.37,2.09c0.26,0.18,0.56,0.27,0.86,0.27  c0.47,0,0.94-0.22,1.23-0.64l11.27-16.1c12.62,12.87,27.43,21.51,41.6,24.06c0.32,0.06,0.64,0.08,0.96,0.08  c2.34,0,4.51-1.52,5.27-3.83l4.79-14.48C90.45,74.84,90.07,72.85,88.82,71.36z M12.87,12.73c0-1.24,0.94-2.32,2.21-2.5l15.09-2.2  C30.3,8.01,30.42,8,30.55,8c0.75,0,1.47,0.33,1.96,0.92l6.62,7.89c0.91,1.09,0.77,2.71-0.32,3.62c-7.31,6.14-8.58,16.94-2.89,24.6  c2.17,2.92,4.72,6.12,7.57,9.52c0.28,0.33,0.54,0.64,0.82,0.96L36.9,66.09C22.74,50.63,12.94,30.72,12.87,12.73z M86.99,75.74  l-4.79,14.48c-0.4,1.21-1.62,1.96-2.85,1.74C65.11,89.39,50.73,80.4,39,68.32l7.33-10.47c1.82,2.1,3.58,4.05,5.23,5.8  c6.55,6.94,17.41,7.57,24.72,1.43c0.53-0.44,1.2-0.65,1.88-0.59c0.68,0.06,1.3,0.38,1.74,0.91l6.62,7.89  C87.1,73.97,87.28,74.89,86.99,75.74z",
    stroke: "#fb503b",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndCall);
export default __webpack_public_path__ + "static/media/end_call.90edbac5080b0516633a7b8ab011f6c7.svg";
export { ForwardRef as ReactComponent };